/**
 * AddEventDropdown
 *
 * A "+" button that triggers the add-event flow.
 */

import { StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

type AddEventDropdownProps = {
  onAddEvent: () => void;
  tintColor: string;
};

export function AddEventDropdown({
  onAddEvent,
  tintColor,
}: AddEventDropdownProps) {
  return (
    <TouchableOpacity
      style={styles.addButton}
      onPress={onAddEvent}
      activeOpacity={0.7}
    >
      <Ionicons name="add" size={24} color={tintColor} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  addButton: {
    width: 36,
    height: 36,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
